import { Moon, Sun } from 'lucide-react';
import useThemeState from '@/states/theme.state';

export const DarkModeToggle = () => {
  const { mode, toggleMode } = useThemeState();
  return (
    <button
      onClick={toggleMode}
      className="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded-md transition-colors"
      aria-label="Toggle dark mode"
    >
      {mode === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};
